import { render, staticRenderFns } from "./split.vue?vue&type=template&id=bd61375e&scoped=true"
import script from "./split.vue?vue&type=script&lang=js"
export * from "./split.vue?vue&type=script&lang=js"
import style0 from "./split.vue?vue&type=style&index=0&id=bd61375e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd61375e",
  null
  
)

export default component.exports